import { render, staticRenderFns } from "./Bloco99Footer.vue?vue&type=template&id=132aaee2&scoped=true&"
import script from "./Bloco99Footer.vue?vue&type=script&lang=js&"
export * from "./Bloco99Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132aaee2",
  null
  
)

export default component.exports